import * as api from "../api/userAPI";
import * as types from "../constants/userConstants";

/**
 * Get notifications for the authenticated user
 */
export const getNotificationsAction = (limit = 20, skip = 0) => async (dispatch) => {
  try {
    const { error, data } = await api.getNotifications(limit, skip);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.GET_NOTIFICATIONS_SUCCESS,
      payload: {
        notifications: data.notifications || [],
        total: data.total || 0,
        unreadCount: data.unreadCount || 0,
      },
      skip,
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.GET_NOTIFICATIONS_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

/**
 * Mark notification as read
 */
export const markNotificationAsReadAction = (notificationId) => async (dispatch) => {
  try {
    const { error, data } = await api.markNotificationAsRead(notificationId);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.MARK_NOTIFICATION_READ_SUCCESS,
      payload: { notificationId },
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.MARK_NOTIFICATION_READ_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

/**
 * Mark all notifications as read
 */
export const markAllNotificationsAsReadAction = () => async (dispatch) => {
  try {
    const { error } = await api.markAllNotificationsAsRead();
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.MARK_ALL_NOTIFICATIONS_READ_SUCCESS,
    });
    return { success: true };
  } catch (error) {
    dispatch({
      type: types.MARK_ALL_NOTIFICATIONS_READ_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

/**
 * Delete a notification
 */
export const deleteNotificationAction = (notificationId) => async (dispatch) => {
  try {
    const { error } = await api.deleteNotification(notificationId);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.DELETE_NOTIFICATION_SUCCESS,
      payload: { notificationId },
    });
    return { success: true };
  } catch (error) {
    dispatch({
      type: types.DELETE_NOTIFICATION_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

/**
 * Add notification from Socket.io (real-time)
 */
export const addNotificationAction = (notification) => ({
  type: types.ADD_NOTIFICATION,
  payload: notification,
});

/**
 * Update notification count
 */
export const updateNotificationCountAction = (count) => ({
  type: types.UPDATE_NOTIFICATION_COUNT,
  payload: count,
});
